export default __webpack_public_path__ + "assets/images/538903f24a130386c86a8cabb8d7dc49.jpg";